module.exports = __webpack_public_path__ + "img/Search.4f1a832c.svg";